import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgSportsEvent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M19.33 15.168c-.437 0-.791-.336-.791-.748 0-.414.354-.75.79-.75.437 0 .79.336.79.75 0 .412-.353.748-.79.748m-3.477-1.08c-1.422 0-2.574-1.09-2.574-2.434s1.152-2.435 2.574-2.435c1.42 0 2.572 1.091 2.572 2.435s-1.152 2.434-2.572 2.434M13 6.999v1.288c0 .42.362.763.807.763.446 0 .806-.343.806-.763V7h1.051c2.39 0 4.499 1.971 4.73 4.221a4.147 4.147 0 01-.23 1.836c.499.275.836.779.836 1.363 0 .872-.748 1.58-1.67 1.58-.509 0-.959-.218-1.264-.557a4.832 4.832 0 01-3.037.494 4.561 4.561 0 01-3.728-3.491c-.282-1.188-1.397-2.032-2.685-2.032H3V7h10zm2.852 3.187c-.856 0-1.552.658-1.552 1.468s.696 1.467 1.551 1.467c.857 0 1.552-.658 1.552-1.467 0-.81-.696-1.468-1.552-1.468zm1.707-6.871l.722.685-2.876 2.72-.723-.684zm-7.266.212l2.354 2.227-.723.683L9.57 4.211zM14.023 0L14 4h-1V0h1z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default tombacIcon('SportsEvent')(SvgSportsEvent);
